// エラーメッセージのインターフェース
export interface ErrorMessageIf {
  [key: string]: ErrorInfo
}

// エラーメッセージ本体(メッセージや補足情報)のインターフェース
export interface ErrorInfo {
  message: string
  needsSupport?: boolean
  note?: string
  title?: string
}

// CS問い合わせ情報のインターフェース
export interface SupportInfo {
  phoneNumber: string
  email: string
}

// エラーコード一覧
export const GLOBAL_ERROR_CODE = {
  /* システム共通 */
  /** 不明なエラー(仮置き) */
  unknownError: '999999'
} as const
export type GlobalErrorCode = (typeof GLOBAL_ERROR_CODE)[keyof typeof GLOBAL_ERROR_CODE]
